import {dateTimeFormat, formatDate, quarterToRomanNumerals} from "@pg-mono/string-utils";

import {getOfferTypeNamePlural, getOfferTypeNameWhat} from "../../offer/helpers/OfferType";
import {OfferType} from "../../offer/types/OfferType";
import {formatMetaRooms} from "../utils/format_meta_rooms";

interface IProps {
    offerType: OfferType;
    offerName: string;
    vendorName: string;
    isSpain: boolean;
    regionName: string;
    parentRegionName: string;
    isDistrictOrNeighborhood?: boolean;
    regionDeclensionWhere?: string;
    minRooms?: number | null;
    maxRooms?: number | null;
    minArea?: number | null;
    maxArea?: number | null;
    constructionDateUpper?: string | null;
}

export const descriptionOfferDetail = (props: IProps) => {
    const typeSingularGenitive = getOfferTypeNameWhat(props.offerType);
    const typePlural = getOfferTypeNamePlural(props.offerType);

    if (props.isSpain) {
        return `Szukasz ${typeSingularGenitive} w Hiszpanii? 🌞 Sprawdź ofertę ${props.offerName} w ${props.parentRegionName}. Zainwestuj za granicą i zacznij generować zyski już dziś! ✅`;
    }

    const regionWhere = props.regionDeclensionWhere || props.regionName;
    const searchPhrase = `Szukasz ${typeSingularGenitive} ${regionWhere}?`;
    const checkPhrase = props.vendorName.endsWith(".")
        ? `Sprawdź ${props.offerName} od ${props.vendorName}`
        : `Sprawdź ${props.offerName} od ${props.vendorName}.`;

    const detailParts: string[] = [];

    if (props.minRooms && props.maxRooms) {
        detailParts.push(formatMetaRooms(props.minRooms, props.maxRooms));
    }

    if (props.minArea && props.maxArea) {
        const areaPart =
            props.minArea === props.maxArea ? `${Math.round(props.minArea)} m2` : `metraże ${Math.round(props.minArea)}-${Math.round(props.maxArea)} m2`;
        detailParts.push(areaPart);
    }

    if (props.constructionDateUpper) {
        const formattedDate = formatDate(props.constructionDateUpper, dateTimeFormat.quarter);
        const datePart = formattedDate ? quarterToRomanNumerals(formattedDate) : "";
        if (datePart) {
            detailParts.push(`termin oddania ${datePart}`);
        }
    }

    const detailPhrase = detailParts.length > 0 ? `Nowe ${typePlural} ${detailParts.join(", ")}.` : "";

    return `${searchPhrase} ${checkPhrase}${detailPhrase ? ` ${detailPhrase}` : ""} Zarezerwuj już dziś✅!`;
};
